var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.75H12M5 17.25H12M5 12H6.75M17.25 6.75H19M17.25 6.75C17.25 7.7165 16.4665 8.5 15.5 8.5C14.5335 8.5 13.75 7.7165 13.75 6.75C13.75 5.7835 14.5335 5 15.5 5C16.4665 5 17.25 5.7835 17.25 6.75ZM17.25 17.25H19M17.25 17.25C17.25 18.2165 16.4665 19 15.5 19C14.5335 19 13.75 18.2165 13.75 17.25C13.75 16.2835 14.5335 15.5 15.5 15.5C16.4665 15.5 17.25 16.2835 17.25 17.25ZM12 12H19M12 12C12 12.9665 11.2165 13.75 10.25 13.75C9.2835 13.75 8.5 12.9665 8.5 12C8.5 11.0335 9.2835 10.25 10.25 10.25C11.2165 10.25 12 11.0335 12 12Z",
    stroke: "#464455",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.1c078db00989d854ca1014a4ca2bd5cd.svg";
export { ForwardRef as ReactComponent };